export const basePath = '/digital-dossier-access-requests';

export * from './getSentDigitalDossierRequests';
export * from './getSharedDigitalDossier';
export * from './receivedAccessRequests';
export * from './updateAccessibleSectionsByUuid';
